<div class="px-4 pb-4 border-bottom-1 surface-border gap-2 flex flex-column align-content-center">
    <span class="p-input-icon-left flex flex-1">
        <i class="pi pi-search"></i>
        <input
            type="text"
            pInputText
            class="w-full outline-none"
            [placeholder]="searchPlaceholder | translate: 'Search'"
            (keyup)="onSearch($event)"
        />
    </span>
</div>

<div class="overflow-auto flex-1">
    @for (item of items; track $index) {
        <div class="px-4 pt-3 flex justify-content-between">
            <li
                class="px-3 overflow-hidden text-overflow-ellipsis white-space-nowrap flex-1"
                [pTooltip]="getDisplayLabel(item)"
                tooltipPosition="top"
            >
                {{ getDisplayLabel(item) }}
            </li>
            <div>
                <img
                    (click)="editClick.emit(item)"
                    src="assets/icons/edit-button.svg"
                    alt="Edit"
                    class="mt-1 cursor-pointer"
                />
                <img
                    (click)="deleteClick.emit(item)"
                    src="assets/icons/delete-button.svg"
                    alt="Delete"
                    class="mx-3 mt-1 cursor-pointer"
                />
            </div>
        </div>
    }
</div>

@if (showAddButton) {
    <div class="px-4 py-3">
        <p-button
            (onClick)="addClick.emit()"
            styleClass="-margin-ml-1 w-full surface-ground hover:surface-hover focus:surface-ground shadow-none border-top-1 surface-border"
            [outlined]="true"
        >
            <ng-template pTemplate="content">
                <div class="w-full flex align-items-center justify-content-center gap-12">
                    <i class="pi pi-plus"></i>
                    {{ addButtonLabel | translate: addButtonDefault }}
                </div>
            </ng-template>
        </p-button>
    </div>
}
